module.exports = __webpack_public_path__ + "static/media/imagem17.140340e0.jpeg";